// intro
import WebbDividerMedium from '../webx/webb-divider-md';
import WebbDividerSmall from '../webx/webb-divider-sm';

import { Row, Col } from 'antd';


export default function IntroHeaderModule () {


  return (
  <>
    <div className={`text-center`} >
      <Row className="" >
        
        <Col xs={0} md={2} lg={2}></Col>

        <Col xs={0} md={20} lg={20}>
          <h2 className='m-0 text-color-wite text-bold p-1'>Inter-Web Notification Service</h2>
          <WebbDividerSmall />
          <h1 className='m-0 text-color-wite text-bold caption-wd'>Event-driven User Engagement - at scale</h1>
          
          <WebbDividerMedium />
          <WebbDividerMedium />
          <i className="bx bxs-bolt-circle text-color-wite text-center" style={{fontSize:'4.2rem'}}></i>
        </Col>

        <Col xs={24} md={0} className="px-3">
          <h2 className='m-0 text-color-wite text-lead'>Inter-Web Notification Service</h2>
          <h1 className='m-0 text-color-wite text-bold caption-md'>Event-driven User engagement - at scale</h1>

          <WebbDividerMedium />
          <i className="bx bxs-bolt-circle text-color-wite text-center" style={{fontSize:'4.2rem'}}></i>
        </Col>

        <Col xs={0} md={2} lg={2}></Col>
        
      </Row>


      
    </div>
  </>

  )
}